import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../../feature'
import type { Manager } from '../manager'

export const createCytoscapeInstance = store.effects.create(
  (feature: Feature, manager: Manager) =>
    feature.actions.bind.observe().pipe(
      rxjs.map(({ data }) => {
        manager.create(data)
      }),
      rxjs.ignoreElements(),
    ),
)
